import type { SVGProps } from 'react';

interface ExpertGlassesProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

export default function ExpertGlasses({
  size = 72,
  ...props
}: ExpertGlassesProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M69.5832 45.1644L65.56 39.8006C64.3309 38.3667 62.5081 37.5762 60.6176 37.6562C60.6176 37.6562 59.8483 37.6396 54.797 37.626C50.0337 37.6132 51.4807 37.626 50.1724 37.626C45.7254 37.626 38.8334 38.6734 38.8334 38.6734M15.2617 31.326L21.1676 32.9741"
        stroke="#291547"
        strokeWidth="2.69984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.8586 30.7598L41.5464 26.3441C40.5346 25.1636 39.034 24.5128 37.4776 24.5787L13.1337 25.2835"
        stroke="#291547"
        strokeWidth="2.69984"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3645 39.0091C21.3645 36.2118 21.6499 32.3444 21.881 31.5164C23.8506 28.1285 32.2152 31.1701 35.0119 31.872C37.8085 32.5739 37.3852 36.6296 37.6212 39.4518C37.7349 40.8109 37.0062 43.9562 35.8793 45.9747C34.6662 48.1476 33.611 50.1191 32.6253 50.5789C30.7239 51.4657 26.3896 49.7833 24.2268 48.7858C22.9405 48.1926 21.9205 46.0576 21.5493 43.7073C21.2963 42.1054 21.3646 40.5268 21.3645 39.0091Z"
        fill="#DDD6F9"
        stroke="#291547"
        strokeWidth="2.69984"
        strokeLinecap="round"
      />
      <path
        d="M2.39454 31.4064C2.39451 28.9397 2.6213 26.1004 2.80669 25.3674C4.3775 22.3659 12.3166 24.3126 13.8987 25.9822C16.0276 28.2288 15.202 30.5557 15.2888 31.7575C15.3756 32.9593 14.7897 35.7432 13.8908 37.5313C12.9231 39.4563 12.0812 41.2028 11.2982 41.6119C9.78775 42.401 5.7814 40.889 4.45806 39.4916C3.54571 38.5281 2.67742 36.6273 2.52939 35.5614C2.33271 34.1452 2.39456 32.8365 2.39454 31.4064Z"
        fill="#DDD6F9"
        stroke="#291547"
        strokeWidth="2.69984"
        strokeLinecap="round"
      />
      <path
        d="M7.46468 28.6224C7.17835 29.8364 6.7059 32.4755 7.10679 33.3202"
        stroke="#291547"
        strokeWidth="2.69984"
        strokeLinecap="round"
      />
      <path
        d="M26.0697 34.7597C25.7833 35.9737 25.3109 38.6129 25.7118 39.4576"
        stroke="#291547"
        strokeWidth="2.69984"
        strokeLinecap="round"
      />
    </svg>
  );
}
